import {
  START_GET_STAFF_LIST,
  SUCCESS_GET_STAFF_LIST,
  ERROR_GET_STAFF_LIST,
  START_CREATE_STAFF,
  SUCCESS_CREATE_STAFF,
  ERROR_CREATE_STAFF,
  START_UPDATE_STAFF,
  SUCCESS_UPDATE_STAFF,
  ERROR_UPDATE_STAFF,
  START_DELETE_STAFF,
  SUCCESS_DELETE_STAFF,
  ERROR_DELETE_STAFF,
} from "Actions/StaffAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  getStaffListAPI,
  createStaffAPI,
  updateStaffAPI,
  deleteStaffAPI,
} from "Api/StaffApi";
import { call, put, takeEvery } from "redux-saga/effects";

function* getStafflistWorker({ payload }) {
  try {
    const res = yield call(getStaffListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_STAFF_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_STAFF_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* createStaffWorker({ payload }) {
  try {
    const res = yield call(createStaffAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_STAFF,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Staff Added Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_STAFF,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updateStaffWorker({ id, payload }) {
  try {
    const res = yield call(updateStaffAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_STAFF,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Staff Updated Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_STAFF,
        payload: res,
      });
    }
  } catch (error) {}
}

function* deleteStaffWorker({ id }) {
  try {
    const res = yield call(deleteStaffAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_STAFF,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Staff deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_STAFF,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message:
            "This driver is assigned in one or more surgeries, so you can not delete it.",
          type: "error",
        },
      });
    }
  } catch (error) {}
}

export function* StaffWatcher() {
  yield takeEvery(START_GET_STAFF_LIST, getStafflistWorker);
  yield takeEvery(START_CREATE_STAFF, createStaffWorker);
  yield takeEvery(START_UPDATE_STAFF, updateStaffWorker);
  yield takeEvery(START_DELETE_STAFF, deleteStaffWorker);
}
